module.exports = __webpack_public_path__ + "img/useCase-1.e182495d.png";